export const COLORS = {
  darkBackground: '#000000',
  androidBlurViewOverlayColor: '#ffffff22',
  popUpBlurBackground: '#222222',
  englishVioletAlt: '#5D3E65',
  darkPurple: '#1D1A31',
  white: '#ffffff',
};
